import { Controller } from "@hotwired/stimulus";
import { formatComputed, formatInput, toDisplay } from "../reconstitution.js";

export default class extends Controller {
  static targets = ["template", "row", "notice", "noticeText"];

  update(state, result, fields, notice) {
    this.rowTargets.forEach((row) => row.remove());
    this.element.hidden = !result.ready;
    this.noticeTarget.hidden = !result.ready || !notice;
    this.noticeTextTarget.textContent = notice ?? "";
    if (!result.ready) return;

    fields.forEach((field, index) => {
      const row = this.templateTarget.content.firstElementChild.cloneNode(true);
      const quantity = `${field.quantityText} ${field.quantity}`;
      const concentration = result.concentrations[index];
      const perUnit = field.quantity === "IU" ? "IU" : "mcg";
      const drawUnits = formatComputed(toDisplay(result.volumeMl, "units"), { grouping: true });
      const values = {
        label: state.compounds.length === 1 ? "Your inputs" : `Your inputs · Compound ${index + 1}`,
        vial: state.entryMode === "strength" ? `Pre-mixed, ${quantity}/mL` : quantity,
        water: state.volumeMl === null ? "Not needed" : `${formatInput(state.volumeMl)} mL`,
        concentration: `${amountText(concentration, field.quantity)}/mL`,
        perUnit: `(${amountText(concentration / 100, perUnit)} per unit)`,
        dose: `${field.doseText} ${field.dose}`,
        draw: `${drawUnits} ${drawUnits === "1" ? "unit" : "units"} · ${amountText(result.volumeMl, "mL")}`,
        doses: result.fullDoses ?? "Depends on fill volume",
      };
      Object.entries(values).forEach(([name, value]) => {
        row.querySelector(`[data-example-field="${name}"]`).textContent = value;
      });
      this.noticeTarget.before(row);
    });
  }
}

function amountText(value, unit) {
  return `${formatComputed(toDisplay(value, unit), { grouping: true })} ${unit}`;
}
